import React from 'react';
import { GenerateStatus } from '@Utils/enums';
import {
  Flex,
  Icon,
  useColorMode,
  useColorStyle,
  Text,
} from '@tonic-one/react';
import { ErrorIcon, PlanStatusIcon, SuccessIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';
import { Info } from '@Components/Common/Info';

interface Props {
  generatedStatus: GenerateStatus;
  [k: string]: any;
}

export const GeneratedStatus: React.FunctionComponent<Props> = ({
  generatedStatus,
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('reportCommon');
  switch (generatedStatus) {
    case GenerateStatus.Successful:
      return (
        <Flex>
          <Icon as={SuccessIcon} color={colorStyle.color.success} mr="2x" />
          <Text>{t('reportCommon.enums.exportStatus.success')}</Text>
        </Flex>
      );
    case GenerateStatus.InProgress:
      return (
        <Flex>
          <Icon as={PlanStatusIcon} color={colorStyle.color.info} mr="2x" />
          <Text>{t('reportCommon.enums.exportStatus.ing')}</Text>
        </Flex>
      );
    case GenerateStatus.Failure:
      return (
        <Flex align="center">
          <Icon as={ErrorIcon} color={colorStyle.color.error} mr="2x" />
          <Text>{t('reportCommon.enums.exportStatus.fail')}</Text>
          <Info
            content={t('reportCommon.tips.hints.reportFail')}
            iconStyle={{ marginLeft: '2x' }}
          />
        </Flex>
      );

    default:
      return <></>;
  }
};
